export const DashboardConst = {
  COUNTRY_ALL: '-1',
  /** 场景不能用-1代表全量值，因为场景可以设置为-1 */
  USER_SCENE_TAG_ALL: '',
  /** 场景上报消息的全量数据。和大盘全量的区别是这个不计算没带场景的上报 */
  USER_SCENE_TAG_TOTAL_OF_ALL_TAGS: 'ALL_USER_SCENE_TAG',
};
